import React, { useContext, useCallback, useMemo } from 'react';
import { useChangeLog } from '../../hooks/useChangelog';
import { ChangelogContextProvider } from './ChangelogContext';
import { CentralProviderContext, useTranslation } from '@michelin/central-provider';
import { DefaultsColumns } from '../../utilities/defaults';
import { DEFAULT_CSV_OPTIONS, handleExportChangelogTableFactory } from './utils';
import { useIsPhoneView } from '../../hooks/useIsPhoneView';
import { onToolbarPreparingFactory } from './utils/onToolbarPreparing';
import { formatFiltersFactory } from './utils/formatFilters';
import { isValueYYYYMMDD } from './utils/isValueYYYYMMDD';
import { formatYYYYMMDDValue } from './utils/formatYYYYMMDDValue';
import { ChangelogTableView } from './ChangelogTableView';
export default function ({ config, app, entity, identifier, dictionary, api, except, height, paperHeight, timeZone, allowExport, csvOptions, onExportError, }) {
    const { t } = useTranslation();
    const providerContext = useContext(CentralProviderContext);
    const { columns = DefaultsColumns(t), filters = {}, filterGroup } = config;
    const formattedFilters = useMemo(() => {
        const formatFilters = formatFiltersFactory({
            isValueDateString: isValueYYYYMMDD,
            formatDate: formatYYYYMMDDValue,
            entity,
        });
        return formatFilters(filters);
    }, [entity, filters]);
    const APP = providerContext.application || app || '';
    const changeLogQuery = useChangeLog({
        api,
        app: APP,
        entity,
        identifier,
        except,
        filters: formattedFilters,
        ignore: config.ignore,
        buildQueryParams: config.buildQueryParams,
    });
    const { dataSource: changeLogDataSource, renderResultsCounter } = changeLogQuery;
    const { reload: reloadChangeLogDataSource } = changeLogDataSource;
    const isPhoneView = useIsPhoneView();
    const handleExportChangelogTable = useCallback(handleExportChangelogTableFactory({
        dataSource: changeLogDataSource,
        handleExportError: onExportError,
        defaultCsvOptions: DEFAULT_CSV_OPTIONS,
        columns,
        csvOptions,
    }), [changeLogDataSource, onExportError, columns, csvOptions]);
    const onToolbarPreparing = useCallback(onToolbarPreparingFactory({
        isPhoneView,
        handleExportChangelog: handleExportChangelogTable,
        reloadData: reloadChangeLogDataSource,
        allowExport: !!allowExport,
        filterGroup,
    }), [isPhoneView, handleExportChangelogTable, reloadChangeLogDataSource, allowExport, filterGroup]);
    return (React.createElement(ChangelogContextProvider, { changelogTableConfig: config, dictionary: dictionary },
        React.createElement(ChangelogTableView, { onToolbarPreparing: onToolbarPreparing, dataSource: changeLogDataSource, paperHeight: paperHeight, height: height, timeZone: timeZone, renderResultsCounter: renderResultsCounter })));
}
;
//# sourceMappingURL=ChangelogTable.js.map